// Serviço para chamadas de API do Register
import { processPlotsData } from "../utils/helpers";
import { storageService } from "./storageService";
import logger from "../../../utils/logger";
import { isMockMode } from "../../../utils/mockData";
import { getPlots } from "../../../services/domain/plotsApiService";
import { createRegistry } from "../../../services/domain/registryApiService";

export const registerService = {
  /**
   * Busca plots da API
   * @returns {Promise<Array>} Array de plots processados
   */
  getPlots: async () => {
    logger.info("Iniciando busca de plots");

    try {
      const enterprise = localStorage.getItem("enterprise") || "ACM";
      const data = await getPlots(enterprise);

      logger.debug("Resposta da API de plots", {
        dataType: typeof data,
        isArray: Array.isArray(data)
      });

      // Processar dados da API
      const plotsArray = processPlotsData(data);

      logger.success("Plots processados", {
        plotsCount: plotsArray.length
      });

      if (plotsArray.length === 0) {
        logger.warn("Nenhum plot encontrado na resposta da API");
      }

      // Salvar no localStorage
      storageService.setPlots(plotsArray);

      return plotsArray;
    } catch (error) {
      logger.error("Erro ao buscar plots", error);
      throw error;
    }
  },

  /**
   * Envia registro de praga
   * @param {Object} registerData - Dados do registro
   * @returns {Promise<Object>} Resposta da API
   */
  saveRegister: async (registerData) => {
    logger.info("Enviando registro", {
      plot: registerData.plot,
      plague: registerData.plague
    });

    // Verificar se está em modo mock
    if (isMockMode()) {
      logger.info("Modo mock: simulando envio de registro (não enviando para API)");
      // Simular delay de rede
      await new Promise(resolve => setTimeout(resolve, 500));
      logger.success("Registro mock processado (não enviado)");
      return { success: true, mock: true };
    }

    try {
      const data = await createRegistry(registerData);
      logger.success("Registro enviado com sucesso");
      return data;
    } catch (error) {
      logger.error("Erro ao enviar registro", error);
      throw error;
    }
  },

  /**
   * Envia registros salvos offline quando volta online
   * @param {Array} registers - Array de registros para enviar
   * @returns {Promise<Object>} Resposta da API
   */
  sendOfflineRegisters: async (registers) => {
    logger.info("Enviando registros offline", {
      count: registers.length
    });

    // Verificar se está em modo mock
    if (isMockMode()) {
      logger.info("Modo mock: simulando envio de registros offline (não enviando para API)");
      // Simular delay de rede
      await new Promise(resolve => setTimeout(resolve, 500));
      logger.success("Registros mock offline processados (não enviados)");
      return { success: true, mock: true };
    }

    try {
      const data = await createRegistry(registers);
      logger.success("Registros offline enviados com sucesso");
      return data;
    } catch (error) {
      logger.error("Erro ao enviar registro", error);
      throw error;
    }
  }
};

